import { mapGetters } from 'vuex';

export default {
	computed: {
		...mapGetters({
			$employees: 'employees/employeesMini'
		})
	},
	methods: {
		getAvatar(employeeId) {
			if (employeeId === null || employeeId === undefined) {
				return null;
			}
			if (this.$employees !== undefined && this.$employees.length > 0) {
				let results = this.$employees.filter(x => x.id === employeeId);
				if (results !== null && results.length > 0) {
					return results[0].avatarUrl;
				}
			}
			return null;
		}
	}
};
